(() => {
  const ROOT_SELECTOR =
    '.one-editorial-article:not([data-one-ready])';


  function init() {
    document
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(setupArticle);
  }


  function setupArticle(root) {
    root.dataset.oneReady = 'true';


    const content =
      root.querySelector(
        '[data-one-source]'
      );


    if (!content) {
      return;
    }


    /* =====================================================
       REMOVE GEO TECHNICAL FOOTER
       ===================================================== */

    removeGeoAttribution(content);


    /* =====================================================
       REMOVE OLD GEO FOOTER

       Removes only:
       - old black product CTA
       - old collection CTA
       - old related stories section
       ===================================================== */

    removeGeoLegacyFooter(content);


    /* =====================================================
       CLASSIFY FIGURES
       ===================================================== */

    Array
      .from(content.children)
      .filter(
        node =>
          node.tagName === 'FIGURE'
      )
      .forEach(classifyFigure);


    /* =====================================================
       FAQ
       ===================================================== */

    buildFaqGroups(content);


    /* =====================================================
       PRODUCT EDIT
       ===================================================== */

    buildProductEdit(content);


    /* =====================================================
       EDITORIAL GALLERIES
       ===================================================== */

    groupEditorialImages(content);


    /* =====================================================
       GENERAL ARTICLE CONTENT
       ===================================================== */

    decorateContent(content);


    /* =====================================================
       MOTION
       ===================================================== */

    setupReveal(root);
  }


  /* =======================================================
     NORMALIZE TEXT
     ======================================================= */

  function normalizeText(value) {
    return (
      value || ''
    )
      .replace(/\s+/g, ' ')
      .trim();
  }


  function normalizedComparison(value) {
    return normalizeText(value)
      .toLowerCase()
      .normalize('NFD')
      .replace(
        /[\u0300-\u036f]/g,
        ''
      );
  }


  /* =======================================================
     REMOVE GEO ATTRIBUTION
     ======================================================= */

  function removeGeoAttribution(content) {
    Array
      .from(content.children)
      .forEach(element => {

        const text =
          normalizedComparison(
            element.textContent
          );


        const geoLink =
          element.querySelector?.(
            'a[href*="one.notagency.net"]'
          );


        const technicalFooter =
          text.startsWith(
            'read the full article at'
          ) ||
          text.startsWith(
            'read full article at'
          ) ||
          text.startsWith(
            'ler o artigo completo em'
          ) ||
          text.startsWith(
            'le o artigo completo em'
          );


        if (
          technicalFooter &&
          (
            geoLink ||
            text.includes('geo atila')
          )
        ) {
          element.remove();
        }

      });
  }


  /* =======================================================
     REMOVE OLD GEO FOOTER
     ======================================================= */

  function removeGeoLegacyFooter(content) {
    const children =
      Array.from(
        content.children
      );


    const relatedHeading =
      children.find(
        element => {

          if (
            !/^H[1-6]$/.test(
              element.tagName || ''
            )
          ) {
            return false;
          }


          const text =
            normalizedComparison(
              element.textContent
            );


          return (
            text ===
            'historias relacionadas'
          );

        }
      );


    if (!relatedHeading) {
      return;
    }


    const oldRelatedGrid =
      relatedHeading
        .nextElementSibling;


    if (
      oldRelatedGrid &&
      oldRelatedGrid.tagName === 'DIV'
    ) {
      const style =
        (
          oldRelatedGrid
            .getAttribute('style') ||
          ''
        )
          .toLowerCase();


      const looksLikeGrid =
        style.includes(
          'display:grid'
        ) ||
        style.includes(
          'display: grid'
        ) ||
        oldRelatedGrid
          .children
          .length >= 2;


      if (looksLikeGrid) {
        oldRelatedGrid.remove();
      }
    }


    let previous =
      relatedHeading
        .previousElementSibling;


    let inspected =
      0;


    while (
      previous &&
      inspected < 5
    ) {
      const candidate =
        previous;


      previous =
        candidate
          .previousElementSibling;


      inspected += 1;


      if (
        candidate.tagName !== 'DIV'
      ) {
        continue;
      }


      const text =
        normalizedComparison(
          candidate.textContent
        );


      const isCollectionModule =
        (
          text.includes(
            'a colecao'
          ) &&
          (
            text.includes(
              'ver toda a colecao'
            ) ||
            text.includes(
              'ver a colecao'
            )
          )
        );


      const isProductCta =
        (
          text.includes(
            'descobrir'
          ) &&
          candidate.querySelector(
            'img'
          ) &&
          candidate.querySelector(
            'a'
          )
        );


      if (
        isCollectionModule ||
        isProductCta
      ) {
        candidate.remove();
      }
    }


    relatedHeading.remove();
  }


  /* =======================================================
     FAQ
     ======================================================= */

  function buildFaqGroups(content) {
    let children =
      Array.from(
        content.children
      );


    let index =
      0;


    while (
      index < children.length
    ) {
      const startIndex =
        findNextMeaningfulIndex(
          children,
          index
        );


      if (
        startIndex === -1
      ) {
        break;
      }


      const firstQuestion =
        children[startIndex];


      if (
        !isQuestionNode(
          firstQuestion
        )
      ) {
        index =
          startIndex + 1;


        continue;
      }


      const pairs =
        [];


      let cursor =
        startIndex;


      while (
        cursor < children.length
      ) {
        const questionIndex =
          findNextMeaningfulIndex(
            children,
            cursor
          );


        if (
          questionIndex === -1
        ) {
          break;
        }


        const question =
          children[
            questionIndex
          ];


        if (
          !isQuestionNode(
            question
          )
        ) {
          break;
        }


        const answerIndex =
          findNextMeaningfulIndex(
            children,
            questionIndex + 1
          );


        if (
          answerIndex === -1
        ) {
          break;
        }


        const answer =
          children[
            answerIndex
          ];


        if (
          answer.tagName !== 'P'
        ) {
          break;
        }


        const answerNodes =
          [
            answer
          ];


        let afterAnswer =
          answerIndex + 1;


        const possibleListIndex =
          findNextMeaningfulIndex(
            children,
            afterAnswer
          );


        if (
          possibleListIndex !== -1
        ) {
          const possibleList =
            children[
              possibleListIndex
            ];


          if (
            possibleList.tagName === 'UL' ||
            possibleList.tagName === 'OL'
          ) {
            answerNodes.push(
              possibleList
            );


            afterAnswer =
              possibleListIndex + 1;
          }

          else {
            afterAnswer =
              possibleListIndex;
          }
        }


        pairs.push({
          question,
          answerNodes
        });


        const nextQuestionIndex =
          findNextMeaningfulIndex(
            children,
            afterAnswer
          );


        if (
          nextQuestionIndex === -1 ||
          !isQuestionNode(
            children[
              nextQuestionIndex
            ]
          )
        ) {
          break;
        }


        cursor =
          nextQuestionIndex;
      }


      if (
        pairs.length < 3
      ) {
        index =
          startIndex + 1;


        continue;
      }


      const faq =
        createFaq(
          content,
          pairs
        );


      children =
        Array.from(
          content.children
        );


      index =
        children.indexOf(faq) + 1;
    }
  }


  function createFaq(
    content,
    pairs
  ) {
    const section =
      document.createElement(
        'section'
      );


    section.className =
      'one-faq one-reveal';


    const inner =
      document.createElement(
        'div'
      );


    inner.className =
      'one-faq__inner';


    const header =
      document.createElement(
        'header'
      );


    header.className =
      'one-faq__header';


    const eyebrow =
      document.createElement(
        'div'
      );


    eyebrow.className =
      'one-faq__eyebrow';


    eyebrow.textContent =
      'THE ONE GUIDE';


    const title =
      document.createElement(
        'h2'
      );


    title.className =
      'one-faq__title';


    title.textContent =
      'Perguntas frequentes';


    const list =
      document.createElement(
        'div'
      );


    list.className =
      'one-faq__list';


    header.appendChild(
      eyebrow
    );


    header.appendChild(
      title
    );


    inner.appendChild(
      header
    );


    inner.appendChild(
      list
    );


    section.appendChild(
      inner
    );


    content.insertBefore(
      section,
      pairs[0].question
    );


    pairs.forEach(
      (pair, pairIndex) => {

        const details =
          document.createElement(
            'details'
          );


        details.className =
          'one-faq__item';


        if (
          pairIndex === 0
        ) {
          details.open =
            true;
        }


        const summary =
          document.createElement(
            'summary'
          );


        summary.className =
          'one-faq__question';


        const questionText =
          document.createElement(
            'span'
          );


        questionText.className =
          'one-faq__question-text';


        questionText.innerHTML =
          pair.question.innerHTML;


        const icon =
          document.createElement(
            'span'
          );


        icon.className =
          'one-faq__icon';


        icon.setAttribute(
          'aria-hidden',
          'true'
        );


        const answer =
          document.createElement(
            'div'
          );


        answer.className =
          'one-faq__answer';


        pair.answerNodes.forEach(
          node => {

            answer.appendChild(
              node
            );

          }
        );


        summary.appendChild(
          questionText
        );


        summary.appendChild(
          icon
        );


        details.appendChild(
          summary
        );


        details.appendChild(
          answer
        );


        list.appendChild(
          details
        );


        pair.question.remove();

      }
    );


    return section;
  }


  function isQuestionNode(element) {
    if (!element) {
      return false;
    }


    const tag =
      element.tagName;


    const allowedHeading =
      tag === 'H2' ||
      tag === 'H3' ||
      tag === 'H4' ||
      tag === 'H5' ||
      tag === 'H6';


    const paragraphQuestion =
      tag === 'P' &&
      element.querySelector(
        'strong, b'
      ) !== null;


    if (
      !allowedHeading &&
      !paragraphQuestion
    ) {
      return false;
    }


    const text =
      normalizeText(
        element.textContent
      );


    return (
      text.length >= 5 &&
      text.length <= 220 &&
      text.endsWith('?')
    );
  }


  function findNextMeaningfulIndex(
    children,
    start
  ) {
    for (
      let index = start;
      index < children.length;
      index += 1
    ) {
      if (
        !isEmptyNode(
          children[index]
        )
      ) {
        return index;
      }
    }


    return -1;
  }


  function isEmptyNode(element) {
    if (!element) {
      return true;
    }


    if (
      element.tagName === 'BR'
    ) {
      return true;
    }


    if (
      element.tagName === 'P'
    ) {
      const text =
        normalizeText(
          element.textContent
        );


      const html =
        (
          element.innerHTML ||
          ''
        )
          .replace(
            /&nbsp;/gi,
            ''
          )
          .replace(
            /<br\s*\/?>/gi,
            ''
          )
          .trim();


      return (
        !text &&
        !html
      );
    }


    return false;
  }


  /* =======================================================
     FIGURE CLASSIFICATION
     ======================================================= */

  function classifyFigure(figure) {
    figure.classList.add(
      'one-figure'
    );


    const productLink =
      figure.querySelector(
        'a[href*="/products/"]'
      );


    if (productLink) {
      figure.classList.add(
        'one-figure--product'
      );
    }

    else {
      figure.classList.add(
        'one-figure--editorial'
      );
    }


    const image =
      figure.querySelector(
        'img'
      );


    if (!image) {
      return;
    }


    const classifyRatio =
      () => {

        if (
          !image.naturalWidth ||
          !image.naturalHeight
        ) {
          return;
        }


        const ratio =
          image.naturalWidth /
          image.naturalHeight;


        if (
          ratio >= 1.45
        ) {
          figure.classList.add(
            'one-figure--landscape'
          );
        }

        else if (
          ratio <= .78
        ) {
          figure.classList.add(
            'one-figure--portrait'
          );
        }

        else {
          figure.classList.add(
            'one-figure--square'
          );
        }

      };


    if (
      image.complete
    ) {
      classifyRatio();
    }

    else {
      image.addEventListener(
        'load',
        classifyRatio,
        {
          once: true
        }
      );
    }
  }


  /* =======================================================
     PRODUCT EDIT
     ======================================================= */

  function buildProductEdit(content) {
    const products =
      Array
        .from(
          content.children
        )
        .filter(
          node =>
            node.matches?.(
              'figure.one-figure--product'
            )
        );


    if (
      !products.length
    ) {
      return;
    }


    if (
      products.length === 1
    ) {
      const figure =
        products[0];


      const wrapper =
        document.createElement(
          'div'
        );


      wrapper.className =
        'one-product-spotlight one-reveal';


      figure
        .parentNode
        .insertBefore(
          wrapper,
          figure
        );


      wrapper.appendChild(
        figure
      );


      return;
    }


    const first =
      products[0];


    const section =
      document.createElement(
        'section'
      );


    section.className =
      'one-product-edit one-reveal';


    section.dataset.count =
      String(
        products.length
      );


    const header =
      document.createElement(
        'div'
      );


    header.className =
      'one-product-edit__header';


    const eyebrow =
      document.createElement(
        'div'
      );


    eyebrow.className =
      'one-product-edit__eyebrow';


    eyebrow.textContent =
      'SHOP THE EDIT';


    const title =
      document.createElement(
        'div'
      );


    title.className =
      'one-product-edit__title';


    title.textContent =
      'Peças em destaque';


    const track =
      document.createElement(
        'div'
      );


    track.className =
      'one-product-edit__track';


    header.appendChild(
      eyebrow
    );


    header.appendChild(
      title
    );


    first
      .parentNode
      .insertBefore(
        section,
        first
      );


    section.appendChild(
      header
    );


    section.appendChild(
      track
    );


    products.forEach(
      figure => {

        const card =
          document.createElement(
            'div'
          );


        card.className =
          'one-product-card';


        card.appendChild(
          figure
        );


        track.appendChild(
          card
        );

      }
    );
  }


  /* =======================================================
     EDITORIAL GALLERIES
     ======================================================= */

  function groupEditorialImages(content) {
    let children =
      Array.from(
        content.children
      );


    let index =
      0;


    while (
      index < children.length
    ) {
      const current =
        children[index];


      if (
        !current.matches?.(
          'figure.one-figure--editorial'
        )
      ) {
        index += 1;


        continue;
      }


      const run =
        [];


      let cursor =
        index;


      while (
        cursor < children.length &&
        children[cursor].matches?.(
          'figure.one-figure--editorial'
        )
      ) {
        run.push(
          children[cursor]
        );


        cursor += 1;
      }


      if (
        run.length >= 2
      ) {
        const gallery =
          document.createElement(
            'div'
          );


        gallery.className =
          'one-editorial-gallery one-reveal';


        gallery.dataset.count =
          String(
            run.length
          );


        content.insertBefore(
          gallery,
          run[0]
        );


        run.forEach(
          figure => {

            gallery.appendChild(
              figure
            );

          }
        );


        children =
          Array.from(
            content.children
          );


        index =
          children.indexOf(
            gallery
          ) + 1;


        continue;
      }


      index += 1;
    }
  }


  /* =======================================================
     CONTENT
     ======================================================= */

  function decorateContent(content) {
    const children =
      Array.from(
        content.children
      );


    const firstParagraph =
      children.find(
        node =>
          node.tagName === 'P'
      );


    if (
      firstParagraph
    ) {
      firstParagraph
        .classList
        .add(
          'one-article-lead'
        );
    }


    children.forEach(
      node => {

        if (
          node.matches?.(
            'p, h2, h3, h4, h5, h6, ul, ol, blockquote, figure'
          )
        ) {
          node
            .classList
            .add(
              'one-reveal'
            );
        }

      }
    );
  }


  /* =======================================================
     REVEAL
     ======================================================= */

  function setupReveal(root) {
    const elements =
      root.querySelectorAll(
        '.one-reveal'
      );


    if (
      !(
        'IntersectionObserver'
        in window
      ) ||
      window
        .matchMedia(
          '(prefers-reduced-motion: reduce)'
        )
        .matches
    ) {
      elements.forEach(
        element => {

          element
            .classList
            .add(
              'is-visible'
            );

        }
      );


      return;
    }


    root.classList.add(
      'one-motion-ready'
    );


    const observer =
      new IntersectionObserver(
        entries => {

          entries.forEach(
            entry => {

              if (
                !entry.isIntersecting
              ) {
                return;
              }


              entry
                .target
                .classList
                .add(
                  'is-visible'
                );


              observer.unobserve(
                entry.target
              );

            }
          );

        },
        {
          threshold:
            .05,

          rootMargin:
            '0px 0px -4% 0px'
        }
      );


    elements.forEach(
      element => {

        observer.observe(
          element
        );

      }
    );
  }


  document.addEventListener(
    'DOMContentLoaded',
    init
  );


  document.addEventListener(
    'shopify:section:load',
    init
  );
})();